import "./App.css";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/appRoutes";
import PageLoader from "./common/pageLoader";
import ToastMessage from "./common/toastMessage";
import SetApiUrl from "./utils/constants";

function App() {
  return (
    <>
      <BrowserRouter>
        <SetApiUrl />
        <PageLoader />
        <ToastMessage />
        <AppRoutes />
      </BrowserRouter>
    </>
  );
}

export default App;
